import { t } from 'ts/helpers/Localization';

export const STATUS = {
  WORK: t('page.team.author.type.work'),
  DISMISSED: t('page.team.author.type.dismissed'),
  STAFF: t('page.team.author.type.staff'),
};

export const WORK_DAYS = {
  HALF: t('page.team.author.days.half'),
  ONE: t('page.team.author.days.one'),
  HALF_ONE: t('page.team.author.days.15'),
  TWO: t('page.team.author.days.two'),
  MORE: t('page.team.author.days.more'),
};
